import { useQuery } from "@tanstack/react-query";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { Link, Navigate, useParams } from "react-router-dom";
import { Brand } from "../components/Brand";
import { LoadingPage } from "../components/UI";
import { api } from "../lib/api";
import type { LegalResponse } from "../types";

export function LegalPage() {
  const { slug } = useParams();
  const query = useQuery({ queryKey: ["public-legal"], queryFn: () => api<LegalResponse>("/api/public/legal") });
  if (slug !== "terms" && slug !== "privacy") return <Navigate to="/" replace/>;
  if (query.isLoading) return <LoadingPage/>;
  const document = query.data!.documents[slug];
  const operator = query.data!.operator;
  return <main className="legal-page"><header><Link to="/"><Brand light/></Link><Link to="/register"><ArrowLeft/>返回注册</Link></header><article>
    <div className="legal-page-title"><span><ShieldCheck/>LEGAL DOCUMENT · {document.version}</span><h1>{document.title}</h1><p>生效日期：{document.effectiveDate}</p></div>
    <div className="legal-operator"><strong>个人信息处理者 / 平台运营主体</strong><span>{operator.companyName || "待管理员填写"}</span><span>{operator.contactEmail || "待管理员填写"} · {operator.contactPhone || "待管理员填写"}</span></div>
    <div className="legal-copy">{document.content.split("\n").map((paragraph, index) => paragraph ? <p key={index}>{paragraph}</p> : <br key={index}/>)}</div>
  </article></main>;
}
